import { GenerationParameters, ProductionDrawing } from './production-drawing.dto';

export enum HookType {
  REGULAR = 'REGULAR',
  FLOOR_RIGHT = 'FLOOR_RIGHT',
  FLOOR_LEFT = 'FLOOR_LEFT',
  WELD = 'WELD',
  SEISMIC = 'SEISMIC',
}

export interface HookMeasurements {
  A?: number;
  B?: number;
}

export interface HookGenerationParameters extends GenerationParameters {
  hookType?: string;
}

export interface HookProductionDrawing extends ProductionDrawing {
  params?: HookParams;
}

export interface HookParams {
  drawingParameters?: HookGenerationParameters;
}
